import { createAction, props } from '@ngrx/store';

export const loadAccountList = createAction('[Account] Load List');

export const loadAccountListSuccess = createAction(
  '[Account] Load List Success',
  props<{ data: any[] }>()
);

export const loadAccountListFailure = createAction(
  '[Account] Load List Failure',
  props<{ error: any }>()
);

export const clearAccountList = createAction('[Account] Clear List');
